import UserActivitySerializer from "../serializers/UserActivitySerializer";
import UserRoleSerializer from "../serializers/UserRoleSerializer";
import UserSerializer from "../serializers/UserSerializer";
import { getToken, getUser } from "../utils/authHelpers";
import { request } from "../utils/requestHelpers";

export default class SecurityRepository {
  USER_BASE = "/api/security";
  USERS_BASE = "/api/users";

  constructor() {
    this.headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer"
    };
  }

  async getUserPermissions(instance) {
    const token = await getToken(instance);
    const userId = getUser(token).oid;
    const path = `${this.USER_BASE}/permissions?uuid=${userId}`;

    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    }, true);

    return Promise.resolve(req.componentPermissions);
  }

  async getUserRoles(instance) {
    const token = await getToken(instance);
    const path = `${this.USER_BASE}/roles`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    }, true);

    return Promise.resolve(req.roles.map(role => (UserRoleSerializer.deSerialize(
      role
    ))));
  }

  async getUser(instance, userId) {
    const token = await getToken(instance);
    const path = `${this.USER_BASE}/user?id=${userId}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    }, true);

    return Promise.resolve(UserSerializer.deSerialize(
      req.user
    ));
  }

  async getUsers(instance) {
    const token = await getToken(instance);
    const path = `${this.USER_BASE}/users`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    }, true);

    return Promise.resolve(req.users.map(user => (UserSerializer.deSerialize(
      user
    ))));
  }

  async updateUser(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.USER_BASE}/user`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify({ user: UserSerializer.serialize(payload) })
    });

    return Promise.resolve(UserSerializer.deSerialize(
      req.user
    ));
  }

  async getAuditLogs(instance, userId) {
    const token = await getToken(instance);
    const path = `${this.USER_BASE}/logs?userId=${userId}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.userActivities) {
      return Promise.resolve(req.userActivities.map(activity => (
        UserActivitySerializer.deSerialize(activity)
      )));
    } else {
      return Promise.resolve([]);
    }
  }

  async getRegionUsers(instance, regionId) {
    const token = await getToken(instance);
    const path = `${this.USER_BASE}/users/region?regionId=${regionId}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.users) {
      return Promise.resolve(req.users.map(user => (
        UserSerializer.deSerialize(user)
      )));
    } else {
      return Promise.resolve([]);
    }
  }

  async updateRegionUser(instance, payloadActiveUser, payloadUser) {
    const token = await getToken(instance);
    const path = `${this.USER_BASE}/user/region`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify({ currentUser: UserSerializer.serialize(payloadActiveUser), user: UserSerializer.serialize(payloadUser) })
    });

    return Promise.resolve(req);
  }

  async getUserByName(instance, name) {
    const token = await getToken(instance);
    const path = `${this.USER_BASE}/usersbyname?UserName=${name}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    return Promise.resolve(req.users.map(user => (UserSerializer.deSerialize(
      user
    ))));
  }

  async getUserByNameOrRegion(instance, name) {
    const token = await getToken(instance);
    const path = `${this.USER_BASE}/usersbynameorregion?UserName=${name}&RegionName=${name}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    return Promise.resolve(req.users.map(user => (UserSerializer.deSerialize(
      user
    ))));
  }

  async getDispatchers(instance) {
    const token = await getToken(instance);
    const path = `${this.USERS_BASE}/dispatchers`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    }, true);

    return Promise.resolve(req.dispatchers);
  }

  async getUserByIdMcLeod(instance, mcId) {
    const token = await getToken(instance);
    const path = `${this.USERS_BASE}/search?id=${mcId}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    }, true);

    return Promise.resolve(req.user);
  }

  async getUserByRoleId(instance, roleId) {
    const token = await getToken(instance);
    const path = `/api/freightmatching/getusersbyroleid?roles=${roleId}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    return Promise.resolve(req.users);
  }
}